module.exports = __webpack_public_path__ + "static/media/aperture.7a030726.svg";